import BarChartScenario from '../bar-chart-scenario/BarChartScenario';
import { BarChartByProps } from '../config';
import { ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { CustomBarChartLabel, OnCategorySelect } from '../bar-select/BarSelectPlugin';
import { saveFilters, setAssetGroups, setAssetGroupsRo } from '@customer/store/slices/filtersSlice';
// import { isEnumValue } from "@customer/shared/utils/typeHelpers";
// import { VILevel, VIType } from "@customer/store/apis/interactionsApi";
import { useGetVehicleGroupsQuery } from '@customer/store/apis/metadataApi';
import { FilterGroup } from '@customer/filters/types';

// TODO: Re-enable the commented code after the UX for bar segment selection has been improved.

export const BarChartByAssetGroup = <T extends ScenarioQueryParams>(props: BarChartByProps) => {
  const dispatch = useAppDispatch();
  const siteId = useAppSelector(state => state.auth.siteId);

  const { data: vehicleGroups } = useGetVehicleGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  // Use the filter group to determine which asset group filter to update (LO or RO).
  const setAssetGroupsAction =
    props.filterGroup === FilterGroup.AssetVI ? setAssetGroupsRo : setAssetGroups;

  const isAssetGroupValid = useCallback(
    (assetGroupId: number): boolean => {
      return (
        typeof vehicleGroups !== 'undefined' &&
        vehicleGroups.some(group => group.id === assetGroupId)
      );
    },
    [vehicleGroups],
  );

  const onCategorySelect = useCallback<OnCategorySelect>(
    ({ id: assetGroupId }: CustomBarChartLabel): void => {
      // Confirm that the selected assetGroup is within the vehicleGroups list.
      if (siteId && isAssetGroupValid(assetGroupId)) {
        dispatch(setAssetGroupsAction([assetGroupId.toString()]));
        dispatch(saveFilters(siteId));
      }
    },
    [dispatch, siteId, isAssetGroupValid, setAssetGroupsAction],
  );

  // const onBarSelect = useCallback<OnBarSelect>(({ id: assetGroupId }: CustomBarChartLabel, datasetId: string): void => {
  //   if (siteId && isAssetGroupValid(assetGroupId)) {
  //     dispatch(setAssetGroupsAction([assetGroupId.toString()]));

  //     // Also filter by VI type if the chart datasetId is a VILevel enum value.
  //     if (isEnumValue(datasetId, VILevel)) {
  //       const typesMatchingLevel: VIType[] = Object.values(VIType).filter((type: VIType) => type.endsWith(datasetId));
  //       dispatch(setVehicleInteractionTypes(typesMatchingLevel));
  //     }

  //     dispatch(saveFilters(siteId));
  //   }
  // }, [dispatch, siteId, isAssetGroupValid, setAssetGroupsAction]);

  return (
    <BarChartScenario<T>
      {...props}
      onCategorySelect={onCategorySelect}
      // Temporarily use the same function for onBarSelect until the UX is improved.
      onBarSelect={onCategorySelect}
    />
  );
};

export default BarChartByAssetGroup;
